import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";

@Component({
  selector: "app-error-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: "./error-dialog.component.html",
  styleUrl: "./error-dialog.component.scss",
})
export class ErrorDialogComponent {
  errorMessage: string = "Unknown Error, please try again";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.errorMessage) this.errorMessage = data.errorMessage;
  }
}
